
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class BeoOrderSummary extends Vue {
	@Prop({ type: Object, required: true }) private order!: Order;
	@Prop({ type: Boolean, default: false }) private showItemDetails!: boolean;
	@Prop({ type: Boolean, default: false }) private showPrices!: boolean;
	@Prop({ type: Boolean, default: false }) private showSplitTaxes!: boolean;
	@Prop({ type: Boolean, default: false }) private showItemDescription!: boolean;
	@Prop({ type: Array, default: () => [] }) private taxInfo!: { name: string, percentageValue: string, amount: number }[];
	@Prop({ type: Array, required: true }) private mergedItems!: OrderMenuGroup[];

	/**
	 * Number of leading spacer columns before the pricing label in the footer
	 *
	 * @return {number}
	 */
	private get footerSpacerColspan(): number {
		return 2 + (this.showItemDetails ? 1 : 0) + (this.showItemDescription ? 1 : 0);
	}
}
